import { PartnerBrandingOptions } from '@saasalerts/common/shared'
import { Text } from '@saasalerts/ui'
import { FC } from 'react'

export const PrintPageFooter: FC<
  React.PropsWithChildren<{
    pageNumber: string
    brandingOptions: PartnerBrandingOptions | undefined
  }>
> = ({ pageNumber, brandingOptions }) => {
  const displaySaasAlertsCoBranding = !(
    brandingOptions?.reportOptions?.hideSaasAlertsCoBranding === true
  )

  return (
    <div className="flex justify-between">
      <Text size="sm">
        {displaySaasAlertsCoBranding &&
          `Copyright ©2021 SaasAlerts. All rights reserved.`}
      </Text>
      <Text size="sm">{pageNumber}</Text>
    </div>
  )
}
